import React, { useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import SearchNav from "./function-components/Searchnav";
import Navbarmenu from "./function-components/Navbarmenu";
import Footer from "./function-components/Footer";
import Home from "./pages/Home";
// import LKMmyXperience from './pages/LKMmyXperience';
import Awards from "./pages/Awards";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "./function-components/PageLayout";
import LearningCalendarPage from "./pages/LearningCalendarPage";
import GalleryPage from "../src/pages/GalleryPage";
import KeyResource from "./pages/KeyResource";
import Offerings from "./pages/Offerings";
import Facultyhub from "./pages/Facultyhub";
import OurLeads from "./pages/OurLeads";
import ShareYourExperience from "./pages/ShareYourExperience";
import Stayknow from "./pages/Stayknow";
import Overview from "./pages/Overview";
import Accounts from "./pages/Accounts";
import Endorsements from "./pages/Endorsements";
import ServiceOfferings from "./pages/ServiceOfferings";
import Feedback from "./function-components/Feedback";
import FeedbackData from "./function-components/FeedbackData";
import TrainingRequest from "./function-components/TrainingRequest";
import ContributeLKM from "./function-components/ContributeLKM";
import Contact from "./function-components/Contact";
import ContributeAdmin from "./function-components/ContributeAdmin";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import AnalyticsPage from "./function-components/AnalyticsPage";
import NavMenubar from "./function-components/NavigationMenu/Navigation";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}
function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  return (
    <>
      <Router>
        <SearchNav />
        <Navbarmenu />
        <NavMenubar />
        <Switch>
          <Route exact path="/newhome">
            <Home />
          </Route>
          {/* <Route exact path="/myxperience">
              <LKMmyXperience />
            </Route> */}
          <Route exact path="/awards">
            <Awards />
          </Route>
          <Route exact path="/analytics">
            <AnalyticsPage />
          </Route>
          <Route exact path="/key-resources">
            <KeyResource />
          </Route>
          <Route exact path="/offerings">
            <Offerings />
          </Route>
          {/* <Route exact path="/FacultyCommunityHub">
              <Facultyhub />
            </Route> */}
          <Route exact path="/OurLeads">
            <OurLeads />
          </Route>
          {/* <Route exact path="/learning-calendar-old">
              <LearningCalendarPage />
            </Route> */}
          <Route exact path="/gallery">
            <GalleryPage />
          </Route>
          {/* <Route exact path="/share">
              <ShareYourExperience />
            </Route> */}
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/stayknow">
            <Stayknow />
          </Route>
          <Route exact path="/Overview">
            <Overview />
          </Route>
          <Route exact path="/AccountsandPractices">
            <Accounts />
          </Route>
          <Route exact path="/Endorsements">
            <Endorsements />
          </Route>
          <Route exact path="/ServiceOfferings">
            <ServiceOfferings />
          </Route>
          <Route exact path="/feedback">
            <FeedbackData />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>
          <Route exact path="/contribute">
            <ContributeAdmin />
          </Route>
        </Switch>
      </Router>
      <TrainingRequest />
      <Feedback />
      <ContributeLKM />
      <Footer />
    </>
  );
}

export default App;
